import { render, staticRenderFns } from "./SidebarSubMenu.vue?vue&type=template&id=7c351511&scoped=true&"
import script from "./SidebarSubMenu.vue?vue&type=script&lang=js&"
export * from "./SidebarSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c351511",
  null
  
)

export default component.exports